export default __webpack_public_path__ + "static/media/pear.a71d6015.webp";